export default [
  "$stateProvider",
  "$urlRouterProvider",
  function ($stateProvider, $urlRouterProvider) {
    // Now set up the states
    $stateProvider.state("cookieSettings", {
      parent: "loginModule",
      url: "/cookieSettings",

      templateProvider: [
        "$q",
        ($q) => {
          return $q((resolve) => {
            // lazy load the view
            require.ensure([], () =>
              resolve(require("./eaCookieSettingsPage/eaCookieSettingsPageModule.html"))
            );
          });
        },
      ],
      controller: "eaCookieSettingsPageModuleController",
      controllerAs: "$ctrl",
      resolve: {
        ctrl: [
          "$q",
          "$ocLazyLoad",
          ($q, $ocLazyLoad) => {
            //console.log("resolve module login ", $ocLazyLoad);
            return $q((resolve) => {
              require.ensure([], () => {
                let module = require("./index.js");
                // console.log(module.default);
                $ocLazyLoad.load({ name: module.default });
                resolve();
              });
            });
          },
        ],
      },
    });
  },
];



// WEBPACK FOOTER //
// ./src/ui/modules/eaLoginMain/eaCookieSettings/routes.js